import { NavigationLinkFragment } from 'graphql/__generated__/types';
import { getPathName } from './common';

export const isActiveExpando = (expandoChildrenLinks: NavigationLinkFragment[], pathname: string) => {
  return expandoChildrenLinks.some((link) => isSidebarActiveLink(link, pathname));
};

export const isSidebarActiveLink = (navigationLink: NavigationLinkFragment, pathname: string) => {
  return getPathName(navigationLink.link.action.resource.value) === pathname;
};
